import {
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  Row,
} from "react-bootstrap";
import { useState } from "react";
import { useEffect } from "react";
import { blogSubCategoryServices } from "../../../../APIServices/SitePilotManagement/BlogManagement/blogSubCategoryServices";
import TextEditor from "../../PageSettings/TextEditor";
import { CiSquarePlus } from "react-icons/ci";
import { GoTrash } from "react-icons/go";

const UpdateBlogPost = ({ 
  blogCategories, 
  blogTitle,
  setBlogTitle,
  categoryId,
  setCategoryId,
  subCategoryId,
  setSubCategoryId,
  shortDescription,
  setShortDescription,
  longDescription,
  setLongDescription,
  tags,
  setTags,
  status,
  setStatus,
}) => {
  const [blogSubCategories, setBlogSubCategories] = useState([]);

  const getBlogSubCategoryList = async () => {
    let data = await blogSubCategoryServices.getBlogSubCategoryList(
      categoryId,
      "active",
    );
    setBlogSubCategories(data?.data || []);
  };

  const addTagsRow = () => {
    setTags([...tags, ""]);
  };

  const removeTagsRow = (index) => {
    const updated = [...tags];
    updated.splice(index, 1);
    setTags(updated);
  };

  const handleTagsChange = (index, value) => {
    const updated = [...tags];
    updated[index] = value;
    setTags(updated);
  };

  useEffect(() => {
    if (categoryId) {
      getBlogSubCategoryList()
    }
  }, [categoryId]);

  return (
    <Card className="border-0 shadow-sm mb-4">
      <Card.Body>
        <Container fluid>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Blog Title</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Title"
                value={blogTitle}
                onChange={(e) => setBlogTitle(e.target.value)}
              />
            </Form.Group>
            <Row className="mb-3">
              <Col>
                <Form.Group>
                  <Form.Label>Category</Form.Label>
                  <Form.Select
                    value={categoryId}
                    onChange={(e) => setCategoryId(e.target.value)}
                  >
                    <option value={""}>Select category</option>
                    {blogCategories?.map(item => (
                      <option value={item?.categoryId}>{item?.name}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>Sub Category</Form.Label>
                  <Form.Select
                    value={subCategoryId}
                    onChange={(e) => setSubCategoryId(e.target.value)}
                  >
                    <option value={""}>Select Sub Category</option>
                    {blogSubCategories?.map(item => (
                      <option value={item?.subCategoryId}>{item?.name}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Cover Image</Form.Label>
                  <Form.Control type="file" />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>Status</Form.Label>
                  <Form.Select
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                  >
                    <option value={"draft"}>Draft</option>
                    <option value={"publish"}>Published</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Form.Group className="mb-3">
              <Form.Label>Short Description</Form.Label>
              <Form.Control
                as="textarea"
                placeholder="Enter Short Description"
                value={shortDescription}
                onChange={(e) => setShortDescription(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Long Description</Form.Label>
              <TextEditor
                placeholder={"Write your blog content here..."}
                editorContent={longDescription}
                setEditorContent={(value) =>
                  setLongDescription(value)
                }
              />
            </Form.Group>
            <Form.Group>
              <div className="hstack gap-2">
                <Form.Label>Tags</Form.Label>
                <CiSquarePlus
                  title="Add More"
                  onClick={addTagsRow}
                  className="mb-1 text-success CP"
                />
              </div>
              <Row>
                {tags?.map((tag, index) => {
                  return (
                    <Col md={3} className="mb-2">
                      <InputGroup key={index} className="mb-2">
                        <Form.Control
                          placeholder="Enter Tag"
                          value={tag}
                          onChange={(e) =>
                            handleTagsChange(
                              index,
                              e.target.value,
                            )
                          }
                        />
                        <InputGroup.Text>
                          <GoTrash
                            style={{ fontSize: 15 }}
                            className="text-danger CP"
                            title="Delete"
                            onClick={() =>
                              removeTagsRow(index)
                            }
                          />
                        </InputGroup.Text>
                      </InputGroup>
                    </Col>
                  );
                })}
              </Row>
            </Form.Group>
          </Form>
        </Container>
      </Card.Body>
    </Card>
  );
};

export default UpdateBlogPost;
